export enum OPA_FLAG {
  // MEW-1062 - SPA | Remove survey pre-qualification limit for those in the test.
  SURVEY_QUALIFICATION_QUESTIONS_WITH_POPUP = 'spa_survey_mew_1062',

  // SJGROW-2815 - Dynamic Screener
  DYNAMIC_SCREENER = 'SJMAND-5363-dynamic-screener',

  // SJGROW-2815 - Persona verification
  PERSONA_VERIFICATION = 'spa_persona__sjgrow_2533',

  // SJGROW-3366 - Promo banner split test
  SPA_PROMO_SJGROW_3366 = 'spa_promo_sjgrow_3366',

  // SJSURVEY-2375 - RepData (Research Defender) token fetch gate
  REPDATA_TOKEN_SJSURVEY_2375 = 'sjsurvey-2375',
}

export enum OPA_VARIABLE {
  // MEW-1062 - SPA | Remove survey pre-qualification limit for those in the test.
  SURVEY_QUALIFICATION_QUESTIONS_PROVIDER_IDS = 'spa_mew_1062_provider_ids',
  SURVEY_QUALIFICATION_SURVEY_MEDLEY_ENABLED = 'spa_mew_1062_survey_medley_enabled',

  // SJGROW-2815 - Dynamic Screener
  DYNAMIC_SCREENER_PROVIDERS = 'enabled_provider_list',
  DYNAMIC_SCREENER_SURVEY_MEDLEY_ENABLED = 'survey_medley_enabled',

  // SJGROW-2815 - Persona verification
  PERSONA_VERIFICATION_ENABLED = 'spa_sjgrow_2533_enabled',

  // SJGROW-3366 - Promo banner split test
  SPA_SJGROW_3366_ENABLED = 'spa_sjgrow_3366_enabled',

  // SJSURVEY-2375 - RepData (Research Defender) token fetch gate
  REPDATA_TOKEN_ENABLED = 'enabled',
}
